import React, { useState, useEffect } from 'react';
import copy from 'copy-to-clipboard';
import Button from 'components/button';
import { useSelector, useDispatch } from 'react-redux';
import { getMerchantBankDetails } from 'store/actions/settings';
import useCopied from 'hooks/useCopied';
import styles from './modal.module.scss';
import { CopyIcon } from '../../../../assets/svgs';

const BankTransfer = ({ onClose }) => {
  const [copied, setCopied] = useCopied(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMerchantBankDetails());
  }, [dispatch]);

  const allBankDetails = useSelector(
    (state) => state?.settings?.bankDetails || [],
  );

  const [bankDetails = {}] = allBankDetails;

  const onCopy = (details) => {
    copy(details.accountNumber);
    setCopied(true);
  };

  return (
    <div>
      <div className={styles.transfer}>
        <div className={styles.transferItem}>
          <div className={styles.transferItemText}>
            <h5>Account Number</h5>
            <p>{bankDetails.accountNumber}</p>
          </div>
          <button
            className={styles.transferItemCopy}
            onClick={() => onCopy(bankDetails)}
            type="button"
          >
            {copied ? (
              <p>Copied</p>
            ) : (
              <>
                <p>Copy</p>
                <CopyIcon />
              </>
            )}
          </button>
        </div>
        <div className={styles.transferItem}>
          <div className={styles.transferItemText}>
            <h5>Bank Name</h5>
            <p>{bankDetails.bankName}</p>
          </div>
        </div>
        <div className={styles.transferItem}>
          <div className={styles.transferItemText}>
            <h5>Account Name</h5>
            <p>{bankDetails.accountName}</p>
          </div>
        </div>
      </div>
      <Button text="Close" onClick={onClose} variant="primary" />
    </div>
  );
};

export default BankTransfer;
